var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 24,
    viewBox: "0 0 74 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40333 1.48362C9.34252 0.53423 10.6225 0 11.9579 0H69C71.7614 0 74 2.23858 74 5V19C74 21.7614 71.7614 24 69 24H11.9579C10.6225 24 9.34252 23.4658 8.40333 22.5164L1.47858 15.5164C-0.448639 13.5682 -0.448639 10.4318 1.47858 8.48362L8.40333 1.48362Z",
    fill: "#6AB10F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferTag);
export default __webpack_public_path__ + "static/media/offer-tag.e8a1f9d9d9532d374f39085543343670.svg";
export { ForwardRef as ReactComponent };